import React, { useState, useRef } from "react";
import PhoneNumberInput from '../../../../components/common/PhoneNumberInput';
import AppFormInput from '../../../../components/ui/AppFormInput';
import apiClient from "../../../../services/api-client";
import { Toast } from 'primereact/toast';
import AppFormSelect from '../../../../components/ui/AppFormSelect';
import { InputSwitch } from "primereact/inputswitch";
import { useMountEffect } from "primereact/hooks";
import StorageHelper from '../../../../utils/storage-helper';


const CreateNewUser = ({ onCloseDialog }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [userStatus, setUserStatus] = useState(false);
    const [userRole, setUserRole] = useState('');
    const [selectedRole, setSelectedRole] = useState(null)
    const [idNumber, setIdNumber] = useState('');
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        idnumber: '',
        userStatus: '',
    });
    const [options, setOptions] = useState([]);

    useMountEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await apiClient.get('system/roles', {
                headers: {
                    Authorization: 'Bearer ' + StorageHelper.get('token'),
                    'Content-Type': 'application/json'
                }
            });
            const newOptions = response.data.responseBody.map(element => ({
                label: element.name,
                value: element.id,
                description: element.description
            }));
            setOptions(newOptions);
        } catch (error) {
            console.error(error);
        }
    };


    const toast = useRef(null);

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validation = validateUser(e)

        if (validation === true) {
            registerUser()
        }
    };


    const registerUser = async () => {
        let userPayload = {
            "operation": "create-user-profile",
            "requestBody": {
                "firstName": firstName,
                "lastName": lastName,
                "emailAddress": email,
                "phoneNumber": phoneNumber,
                "idnumber": idNumber,
                "isActive": true,
                "locked": false,
                "enabled": true,
                "userType": "EMPLOYEE",
                "userRole": userRole
            }
        };

        const token = StorageHelper.get('token')

        const config = {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        };

        try {
            const response = await apiClient.post('user/create/employee', userPayload, config);
           // //console.log(response.data);
            if (response.data.status === 'FAILED') {
                toast.current.show({ severity: 'error', sticky: true, summary: 'Failed', detail: response.data.message });
            } else {
                onCloseDialog({ success: true });
            }
        } catch (error) {
            //console.error(error);
        }
    };

    const validateUser = (e) => {
        let formIsValid = true;
        const newErrors = { ...errors };

        // Validate First Name
        if (!firstName.trim()) {
            newErrors.firstName = 'First name is required';
            formIsValid = false;
        } else {
            newErrors.firstName = '';
        }

        // Validate Last Name
        if (!lastName.trim()) {
            newErrors.lastName = 'Last name is required';
            formIsValid = false;
        } else {
            newErrors.lastName = '';
        }

        // Validate Email
        if (!email.trim()) {
            newErrors.email = 'Email is required';
            formIsValid = false;
        } else if (!validateEmail(email)) {
            newErrors.email = 'Invalid email format';
            formIsValid = false;
        } else {
            newErrors.email = '';
        }

        // Validate Phone Number
        if (!phoneNumber.trim()) {
            newErrors.phoneNumber = 'Phone number is required';
            formIsValid = false;
        } else if (!/^\d{9,15}$/.test(phoneNumber)) {
            newErrors.phoneNumber = 'Please enter a valid phone number';
            formIsValid = false;
        } else {
            newErrors.phoneNumber = '';
        }

        // Validate User Status
        if (typeof userStatus !== 'boolean') {
            newErrors.userStatus = 'User Status must be true or false';
            formIsValid = false;
        } else {
            newErrors.userStatus = '';
        }

        // If form is valid, submit the data
        if (formIsValid) {
            setErrors({});
            return true;
        } else {
            setErrors(newErrors);
            return false;
        }
    };

    const handleUserRoleChange = (val)=>{

        setUserRole(val)

        options.forEach(element => {
            //console.log(element)

            if(element.value === val){
                setSelectedRole(element)
            }
        });
    }
   

    return (
        
        <>
            <Toast ref={toast} />
            <div className="w-full mt-2">
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <AppFormInput label="First Name" id="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} error={errors.firstName} />

                    <AppFormInput label="Last Name" id="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} error={errors.lastName} />

                    <AppFormInput label="Email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} error={errors.email} />

                    <AppFormInput label="National ID Number" id="idNumber" value={idNumber} onChange={(e) => setIdNumber(e.target.value)} error={errors.idNumber} />

                    <PhoneNumberInput label="Phone" value={phoneNumber} onChange={(val) => setPhoneNumber(val)} error={errors.phoneNumber} />

                    <AppFormSelect
                        label="User Role"
                        id="userRole"
                        value={userRole}
                        options={options}
                        optionLabel="label"
                        optionValue="value"
                        onChange={(e) => handleUserRoleChange(e.target.value)}
                        placeholder="Select a role"
                        hint={selectedRole?.description}
                    />

                    <div className="form-control w-full mt-2">
                        <label className="label cursor-pointer justify-start gap-4 p-4 border border-base-200 rounded-lg bg-base-50/50 hover:bg-base-100 transition-colors">
                            <InputSwitch
                                id="value"
                                name="value"
                                checked={userStatus}
                                onChange={(e) => {
                                    let message = !userStatus ? 'User will be created active' : 'User will be created disabled';
                                    toast.current.show({ severity: 'info', summary: 'User Status', detail: message });
                                    setUserStatus(e.value);
                                }}
                            />
                            <span className="label-text font-medium text-gray-700">
                                {userStatus ? 'Create and set it disabled?' : 'Activate account upon creation?'}
                            </span>
                        </label>
                    </div>

                    <div className="mt-6 flex justify-end pt-4 border-t border-base-200">
                        <button type="submit" className="btn btn-primary px-8 text-white rounded-lg shadow-sm">
                            <i className="pi pi-check"></i> Register User
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default CreateNewUser;
